/* eslint-disable */
<template>
  <div class="container-fluid no-padding">
    <div class="row bg-primary-dark">
      <div class="col-md-8 mb-2 mt-2 align-middle">
        <h4>Ürünler Listesi, Üretim Şemaları</h4>
      </div>
      <div class="col-md-4 mb-2 mt-2">
        <router-link class="btn btn-more-radius btn-success float-right" v-if="canCreateProduct"
          to="/uretim/urun-olustur">Yeni Ürün Oluştur</router-link>
        <router-link class="btn btn-more-radius btn-primary float-right mr-2" v-if="canCalculateProduction && isCalculationEnabled"
          v-bind:to="'/uretim/hesapla/' + selectedProducts">Çoklu Üretim Hesapla</router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-wait for="urunler-loading">
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Ürünler yükleniyor...</p>
            </div>
          </template>
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th style="width: 4%;" scope="col">#</th>
                <th style="width: 8%;" scope="col">OLUŞTURMA</th>
                <th style="width: 20%;" scope="col">ÜRETİM BİLGİSİ</th>
                <th style="width: 20%;" scope="col">HEDEF ÜRÜN</th>
                <th style="width: 10%;" scope="col">MALİYET</th>
                <th style="width: 9%;" scope="col">OLUŞTURAN</th>
                <th scope="col">KOMUTLAR</th>
              </tr>
            </thead>
            <tbody class="tbody-margin">
              <template v-for="(urun, index) in urunler">
                <tr :key="'trow-first-' + urun.URUN_ID">
                  <td class="align-middle text-center">
                    <div class="custom-control custom-checkbox text-center">
                      <input type="checkbox" class="custom-control-input" :value="urun.URUN_ID"
                        v-model="selectedProducts" :id="'all-prods-' + index">
                      <label class="custom-control-label" v-bind:for="'all-prods-' + index"></label>
                    </div>
                  </td>
                  <td class="align-middle">{{urun.URUN_CREATED}}</td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0">{{urun.URUN_NAME}}</p>
                      <small class="text-muted">{{urun.URUN_DESCRIPTION}}</small>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0">{{urun.MALZEME_NAME}}</p>
                      <small class="text-muted">{{urun.MALZEME_CODE}}</small>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0">{{urun.UNIT_PRICE}}</p>
                      <small class="text-muted">$</small>
                    </div>
                  </td>
                  <td class="align-middle"><div class="text-truncate">{{urun.PERSONEL_NAME}}</div></td>
                  <td class="align-middle text-center">
                    <router-link role="button" v-bind:to="'/uretim/hesapla/' + urun.URUN_ID" :disabled="!canCalculateProduction" class="btn btn-outline-primary btn-more-radius">
                      <i class="fas fa-calculator text-primary"></i>&nbsp;&nbsp;Üretim Hesapla</router-link>
                    <router-link role="button" v-bind:to="'/uretim/urun-olustur/' + urun.URUN_ID" v-if="canCreateProduct"
                      :disabled="!canCreateProduct" class="btn btn-outline-primary btn-more-radius">
                      <i class="far fa-edit text-primary"></i>&nbsp;&nbsp;Düzenle</router-link>
                    <button class="btn btn-outline-danger btn-more-radius" @click="selectProduct(index)" 
                      v-if="canDeleteProduct" :disabled="!canDeleteProduct"
                      data-toggle="modal" data-target="#deleteProductModal" aria-expanded="false">
                      <i class="fas fa-trash-alt text-danger"></i>&nbsp;&nbsp;Ürünü Sil</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-wait>
      </div>
    </div>
    <div v-if="canDeleteProduct" class="modal fade bd-example-modal-lg" id="deleteProductModal" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Aşağıda bilgileri yer alan ürünü silmek istediğinizden emin misiniz ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="product-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Ürün Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="form-group">
                      <label for="malzeme-kod">Ürün Adı</label>
                      <input type="text" readonly class="form-control" id="malzeme-kod"
                        :value="product.URUN_NAME">
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="malzeme-name">Ürün Açıklaması</label>
                    <textarea readonly class="form-control mb-3" id="malzeme-name"
                      :value="product.URUN_DESCRIPTION"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteProduct()" class="btn btn-danger">Ürünü Sil</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'UrunlerPage',
  components: {
  },
  data () {
    return {
      urunler: [],
      product: {},
      selectedProducts: []
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canCreateProduct : function() { return this.$store.getters.userCanCreateProduct },
    canDeleteProduct : function() { return this.$store.getters.userCanDeleteProduct },
    canCalculateProduction : function() { return this.$store.getters.userCanCalculateProduction },
    isCalculationEnabled : function() { return this.selectedProducts.length > 0; }
  },
  methods: {
    getProducts() {
      this.$wait.start('urunler-loading')
      axios.post('/api/stok/tum-urunler?sessionid=' + this.getSessionId + '&searchFilter=',
        { 'SessionId': this.getSessionId, 'SearchFilter': '' })
      .then(response => {
        console.log(response.data)
        this.urunler = response.data
        this.$wait.end('urunler-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('urunler-loading')
      })
    },
    deleteProduct() {
      this.$wait.start('product-deleting')
      axios.post('/api/stok/urun-sil?sessionid=' + this.getSessionId + '&urunId=' + this.product.URUN_ID)
      .then(response => {
        this.$wait.end('product-deleting')
        this.getProducts()
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('product-deleting')
      })
    },
    selectProduct(index) {
      this.product = this.urunler[index]
    }
  },
  mounted() {
    this.getProducts()
    console.log(this.canCreateProduct)
    console.log(this.canDeleteProduct)
    console.log(this.canCalculateProduction)
  }
}
</script>

<style scoped>
  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .75rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/UrunlerPage.vue